import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './components/App';
import '../public/bower_components/jquery/dist/jquery.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import './styles/app.scss';
import '../public/js/vendor/select2/select2.css';
import '../public/js/vendor/select2/select2.js';
import '../public/bower_components/x-editable/dist/bootstrap3-editable/js/bootstrap-editable.js';
import '../public/bower_components/x-editable/dist/inputs-ext/address/address.js';
import '../public/bower_components/x-editable/dist/inputs-ext/typeaheadjs/typeaheadjs.js';
import '../public/bower_components/eonasdan-bootstrap-datetimepicker/src/js/bootstrap-datetimepicker.js';

ReactDOM.render(<App />, document.getElementById('app'));



// WEBPACK FOOTER //
// ./src/index.js